import { Component, Inject, OnDestroy, OnInit, } from '@angular/core';
import { MatLegacyDialog as MatDialog, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ReportsService, DepotService, ContainerAvailabilityReportData, AssetTypeClassification } from 'src/shared/service-proxies/service-proxies';
import { PageHelperService } from '../helpers/page-helper.service';
import { PagebaseComponent } from '../pagebase/pagebase.component';
import { ApplicationStatusService } from '../services/application-status.service';
import * as moment from 'moment';
import { SessionStorageService } from '../services/session-storage.service';
import { Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { VehicleTypeHelper } from '../helpers/VehicleTypeHelper';
import { LocalStorageService } from '../services/local-storage.service';
import { CustomerSettings } from '../services/customer-settings-service';
import { Observable } from 'rxjs';
import { startWith, map } from 'rxjs/operators';
import { forEach } from '@angular-devkit/schematics';
import { AuthService } from '../security/auth.service';

export class DropDownListItem {
  constructor(id?: string, name?: string) {
    this.id = id,
    this.name = name;
  }

  id: string;
  name: string;
}

@Component({
  selector: 'app-container-availability-report-component',
  templateUrl: './container-availability-report.component.html',
  styleUrls: ['./container-availability-report.component.scss']
})
export class ContainerAvailabilityReportComponent extends PagebaseComponent implements OnDestroy, OnInit {
  // Private variables
  customerId: string;
  data: ContainerAvailabilityReportData;
  regionList: DropDownListItem[];
  allDepots: DropDownListItem[];
  depotList: DropDownListItem[];
  locationList: DropDownListItem[];
  selectedRegionId: string;
  selectedDepotId: string[];
  selectedLocationId: string;
  selectedVehicleType: string;
  selectedFromDate = new UntypedFormControl(this.getDefaultFromDate());
  selectedToDate = new UntypedFormControl(this.getDefaultToDate());
  selectedShouldBeSingleOperation: boolean = false;
  assetTypeSearchControl: UntypedFormControl = new UntypedFormControl();
  expandedCategories: string[] = [];

  private apiCall;

  // Public variables
  loading: boolean = true;

  // Constuctor
  constructor(
    private _depotService: DepotService,
    private _reportsService: ReportsService,
    private sessionStorageService: SessionStorageService,
    private localStorageService: LocalStorageService,
    private router: Router,
    private customerSettings: CustomerSettings,
    private authService: AuthService,
    pageHelperService: PageHelperService,
    applicationStatusService: ApplicationStatusService
    ) {
    super(pageHelperService, applicationStatusService, customerSettings, "Container Availability Report");
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.unsubscribe()
  }

  unsubscribe() { 
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }
  }

  reset() {
    this.data = null;
    if (this.apiCall) {
      this.apiCall.unsubscribe();
    }  
  }

  getDefaultFromDate() {
    var d = new Date();

    d.setDate(d.getDate() - (d.getDay() + 6) % 7);
    d.setDate(d.getDate() - 7);

    return d;
  }

  getDefaultToDate() {
    var d = this.getDefaultFromDate();

    return new Date(d.getFullYear(), d.getMonth(), d.getDate() + 6);
  }

  // Get the view data
  getData() {
    this.data = null;

    let selectedRegionId = this.sessionStorageService.getItem("container-availability-report-selectedRegionId");
    if(selectedRegionId) {
      this.selectedRegionId = selectedRegionId;
    }
    else {
      this.selectedRegionId = null;
    }
    let selectedDepotId = [];
    if (this.sessionStorageService.getItem("container-availability-report-selectedDepotId")) {
      try {
        selectedDepotId = JSON.parse(this.sessionStorageService.getItem("container-availability-report-selectedDepotId"));
        this.selectedDepotId = selectedDepotId;
      }
      catch {
        selectedDepotId = [];
        this.selectedDepotId = [];
      }
    }
    else {
      this.selectedDepotId = [];
    }
    let selectedLocationId = this.sessionStorageService.getItem("container-availability-report-selectedLocationId");
    if(selectedLocationId) {
      this.selectedLocationId = selectedLocationId;
    }
    else {
      this.selectedLocationId = null;
    }
    let selectedVehicleType = this.sessionStorageService.getItem("dashboard-active-selectedVehicleType");
    if(selectedVehicleType) {
      selectedVehicleType = JSON.parse(this.sessionStorageService.getItem("dashboard-active-selectedVehicleType"));
      this.selectedVehicleType = selectedVehicleType;
    }
    let selectedFromDate = this.localStorageService.getItem("container-availability-report-selectedFromDate");
    if(selectedFromDate) {
      selectedFromDate = JSON.parse(selectedFromDate);
      this.selectedFromDate = new UntypedFormControl(selectedFromDate);
    }
    let selectedToDate = this.localStorageService.getItem("container-availability-report-selectedToDate");
    if(selectedToDate) {
      selectedToDate = JSON.parse(selectedToDate);
      this.selectedToDate = new UntypedFormControl(selectedToDate);
    }    

    if(this.customerId != this.pageHelperService.selectedCompanyId) {
      console.log("loading regions & depots");
      this.loading = true;
      this.setIsLoading(this.loading);

      this.customerId = this.pageHelperService.selectedCompanyId;
      this._depotService.getRegions(this.pageHelperService.selectedCompanyId).subscribe(data => {
        const regionList: DropDownListItem[] = [];
        data.forEach(region => {
          let regionItem = new DropDownListItem()
          regionItem.id = region.id;
          regionItem.name = region.name;
          regionList.push(regionItem)
        });
        
        this.regionList = regionList;
        this._depotService.getUserDepots(this.pageHelperService.selectedCompanyId).subscribe(data => {    
          const depotList: DropDownListItem[] = [];
          data.forEach(depot => {
            let depotItem = new DropDownListItem()
            depotItem.id = depot.id;
            depotItem.name = depot.name;
            depotList.push(depotItem)
          });
          
          this.allDepots = depotList;
          this.depotList = depotList;
          this.loading = false;
          this.setIsLoading(this.loading);
        });
      });
    }

    console.log("loading data");
    this.loading = true;
    this.setIsLoading(this.loading);
    
    this.apiCall = this._reportsService
      .getContainerAvailabilityReport(
        this.customerId,
        this.getRegionId(selectedRegionId),
        selectedDepotId,
        this.selectedShouldBeSingleOperation,
        this.getLocationId(selectedLocationId),
        this.getAssetTypeClassification(selectedVehicleType),
        this.getFromDate(selectedFromDate),
        this.getToDate(selectedToDate),
        true,
        false,
        true,
        true,
        false)
      .subscribe(data => {
        this.data = data;

        if (this.data.regionDepotIds && this.data.regionDepotIds.length > 0) {
          this.depotList = this.allDepots.filter(item => this.data.regionDepotIds.includes(item.id));
        }
        else {
          this.depotList = this.allDepots;
        }

        this.locationList = data.locations?.map(l => <DropDownListItem>{ id: l.id, name: l.displayName });

        this.loading = false;
        this.setIsLoading(this.loading);
      }, error => {
        debugger;
      });
  }

  getRegionId(selectedRegionId) {
    if (!selectedRegionId) {
      return null;
    }

    return selectedRegionId;
  }

  getDepotId(selectedDepotId) {
    if (!selectedDepotId) {
      return null;
    }

    return selectedDepotId;
  }

  getLocationId(selectedLocationId) {
    if (!selectedLocationId) {
      return null;
    }

    return selectedLocationId;
  }

  getAssetTypeClassification(selectedVehicleType: string) {
    return !selectedVehicleType ? AssetTypeClassification.All : VehicleTypeHelper.ConvertVehicleTypeNameToAssetTypeClassification(selectedVehicleType)
  }

  getFromDate(selectedFromDate: string) {
    if (!selectedFromDate) {
        return moment(this.getDefaultFromDate());
    }

    return moment(selectedFromDate);
  }

  getToDate(selectedToDate: string) {
    if (!selectedToDate) {
        return moment(this.getDefaultToDate());
    }

    return moment(selectedToDate);
  }  

  fromDateFilterChanged(newValue) {
    if (newValue) {
      this.localStorageService.setItem("container-availability-report-selectedFromDate", JSON.stringify(newValue));
    }
    else {
      this.localStorageService.removeItem("container-availability-report-selectedFromDate");
    }

    this.getData();
  }

  toDateFilterChanged(newValue) {
    if (newValue) {
      this.localStorageService.setItem("container-availability-report-selectedToDate", JSON.stringify(newValue));
    }
    else {
      this.localStorageService.removeItem("container-availability-report-selectedToDate");
    }

    this.getData();
  }  

  regionChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("container-availability-report-selectedRegionId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("container-availability-report-selectedRegionId");
    }

    this.selectedDepotId = null;
    this.sessionStorageService.removeItem("container-availability-report-selectedDepotId");    
    this.getData();
  }

  depotChange(newValue) {
    if (newValue.length > 0) {
      this.sessionStorageService.setItem("container-availability-report-selectedDepotId", JSON.stringify(newValue));
    } else {
      this.sessionStorageService.removeItem("container-availability-report-selectedDepotId")
    }
  }

  dropdownChanged(opened) {
    if (!opened) {
      this.getData();
    }
  }

  locationChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("container-availability-report-selectedLocationId", newValue);
    }
    else {
      this.sessionStorageService.removeItem("container-availability-report-selectedLocationId");
    }

    this.getData();
  }

  operationChanged() {
    this.selectedShouldBeSingleOperation = !this.selectedShouldBeSingleOperation
    this.getData();
  }

  selectedVehicleTypeValueChange(newValue) {
    if (newValue) {
      this.sessionStorageService.setItem("dashboard-active-selectedVehicleType", JSON.stringify(newValue));
    }
    else {
      this.sessionStorageService.removeItem("dashboard-active-selectedVehicleType");
    }

    this.getData();    
  }

  toggleRow(category) {
    if (this.expandedCategories.includes(category)) {
      const index = this.expandedCategories.indexOf(category);
      if (index > -1) {
        this.expandedCategories.splice(index, 1);
      }
    } else {
      this.expandedCategories.push(category);
    }
  }
}